var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('h1',{staticStyle:{"margin-left":"20px"}},[_vm._v("廠商名稱: "+_vm._s(_vm.vendor_name))])]),_c('v-row',[_c('doctor-overview',{attrs:{"vendor_id":_vm.vendor_account_id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }